import { configureLocalization } from '@lit/localize';
import { sourceLocale, targetLocales } from '../../generated/locale-codes.js';
export const localizationConfig = {
    getLocale: undefined,
    setLocale: undefined,
};
export const initConfig = (localeTemplateMap) => {
    const config = configureLocalization({
        sourceLocale,
        targetLocales,
        loadLocale: async (locale) => {
            const templates = await localeTemplateMap.get(locale);
            if (templates?.length > 1) {
                const mergedTemplate = templates.reduce((accumulator, currentValue) => {
                    return {
                        templates: Object.assign(accumulator.templates, currentValue.templates),
                    };
                });
                return mergedTemplate;
            }
            else {
                return templates;
            }
        },
    });
    localizationConfig.getLocale = config.getLocale;
    localizationConfig.setLocale = config.setLocale;
};
//# sourceMappingURL=localization-provider.js.map